module.exports = __webpack_public_path__ + "b8cf129b012415c8c6241491ad637aef.glb";